/**
 * Modern JavaScript optimization - Remove legacy polyfills for modern browsers
 */
(function() {
  'use strict';

  // Detect modern browser capabilities
  const isModernBrowser = function() {
    return (
      'fetch' in window &&
      'Promise' in window &&
      'Symbol' in window &&
      'WeakMap' in window &&
      'requestIdleCallback' in window &&
      'IntersectionObserver' in window &&
      CSS && CSS.supports && CSS.supports('display', 'grid')
    );
  };

  // Remove legacy polyfills if modern browser
  function removeLegacyCode() {
    if (!isModernBrowser()) {
      return; // Keep legacy code for older browsers
    }

    // Remove Facebook emoji polyfills if they exist
    const facebookEmojiScripts = document.querySelectorAll('script[src*="emoji-datasource-facebook"]');
    facebookEmojiScripts.forEach(script => script.remove());

    // Remove other legacy polyfills
    const legacyScripts = document.querySelectorAll([
      'script[src*="polyfill"]',
      'script[src*="babel-polyfill"]',
      'script[src*="es6-promise"]',
      'script[src*="whatwg-fetch"]'
    ].join(','));
    
    legacyScripts.forEach(script => {
      console.log('Removing legacy script:', script.src);
      script.remove();
    });
  }

  // Optimize third-party scripts for modern browsers
  function optimizeThirdPartyScripts() {
    // Facebook SDK optimization
    if (window.fbAsyncInit) {
      // Use modern Facebook SDK features only
      window.fbAsyncInit = function() {
        if (FB && FB.init) {
          FB.init({
            appId: 'your-app-id',
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v18.0' // Use latest version
          });
        }
      };
    }

    // Optimize Google Analytics if present
    if (window.gtag) {
      // Use modern gtag approach instead of legacy analytics.js
      window.gtag('config', 'GA_TRACKING_ID', {
        send_page_view: false // Manual page view tracking for SPA behavior
      });
    }
  }

  // Replace legacy Array methods with modern equivalents
  function optimizeArrayMethods() {
    // These are already native in modern browsers, no polyfills needed
    if (Array.prototype.find && Array.prototype.findIndex && Array.prototype.includes) {
      console.log('Modern Array methods available natively');
    }
  }

  // Use modern fetch instead of XMLHttpRequest where possible
  function modernizeFetch() {
    // Replace legacy XHR with fetch for supported browsers
    if (window.fetch && window.XMLHttpRequest) {
      const originalXHR = window.XMLHttpRequest;
      
      // Intercept XHR and suggest fetch where appropriate
      window.XMLHttpRequest = function() {
        console.warn('Consider using fetch() instead of XMLHttpRequest for better performance');
        return new originalXHR();
      };
    }
  }

  // Optimize CSS for modern browsers
  function optimizeCSS() {
    // Use modern CSS features detection
    if (CSS && CSS.supports) {
      // Add class for modern CSS support
      document.documentElement.classList.add('modern-css');
      
      // Check for CSS Grid support
      if (CSS.supports('display', 'grid')) {
        document.documentElement.classList.add('css-grid');
      }
      
      // Check for CSS Custom Properties
      if (CSS.supports('color', 'var(--test)')) {
        document.documentElement.classList.add('css-custom-properties');
      }
    }
  }

  // Initialize optimizations
  function init() {
    removeLegacyCode();
    optimizeThirdPartyScripts();
    optimizeArrayMethods();
    modernizeFetch();
    optimizeCSS();
    
    console.log('Modern JavaScript optimizations applied for', isModernBrowser() ? 'modern' : 'legacy', 'browser');
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();